// extracted by mini-css-extract-plugin
export default {"header":"Header_header__ionDT","header__logo":"Header_header__logo__AxiaP","flex-1":"Header_flex-1__dcLQj","header__title-wrapper":"Header_header__title-wrapper__pfFXz"};